import { Components, Theme } from '@mui/material';
import { ICON_SIZES } from '../Icon/const';

export const MuiToggleButtonGroup = {
  defaultProps: {
    exclusive: true,
  },
  styleOverrides: {
    root: {
      '&.MuiToggleButtonGroup-corner-pill': {
        borderRadius: '16px',
      },
    },
    grouped: ({ theme }) => ({
      borderColor: theme.palette.neutral.outlineVariant,
      '&:not(:first-of-type)': {
        borderLeft: 0,
        marginLeft: 0,
      },
    })
  }
} as Components<Theme>['MuiToggleButtonGroup'];

export const MuiToggleButton = {
  defaultProps: {
    disableRipple: true,
    variant: 'outlined',
  },
  styleOverrides: {
    sizeSmall: {
      height: 24,
    },
    sizeMedium: {
      height: 32,
    },
    sizeLarge: {
      height: 40,
    },
    root: ({ theme, ownerState }) => {
      const color = ownerState.color || 'standard';

      const colorPalette = color === 'standard' ?
        {
          container: theme.palette.neutral.surface,
          onContainer: theme.palette.neutral.onSurface,
          selectedContainer: theme.palette.neutral.surfaceVariant,
          onSelectedContainer: theme.palette.neutral.onSurface,
        } : {
          container: theme.palette[color].container,
          onContainer: theme.palette[color].main,
          selectedContainer: theme.palette[color].main,
          onSelectedContainer: theme.palette[color].onMain,
        };

      return {
        borderRadius: 4,
        gap: theme.spacing(1),
        color: colorPalette.onContainer,
        ...theme.createStateLayer(colorPalette.container),
        ...theme.typography.button,
        '&.Mui-selected': {
          color: colorPalette.onSelectedContainer,
          backgroundColor: colorPalette.selectedContainer,
          ...theme.createStateLayer(colorPalette.selectedContainer),
          '& svg, & .MuiIcon-root': {
            color: colorPalette.onSelectedContainer
          },
        },
        '& svg, & .MuiIcon-root': {
          fontSize: ICON_SIZES.SMALL,
          color: color === 'standard' ? theme.palette.secondary.outline : theme.palette[color].outline,
        },
        '&.MuiToggleButton-corner-pill': {
          borderRadius: 16,
        }
      };
    },
  }
} as Components<Theme>['MuiToggleButton'];